<div
  *transloco="let translate"
  [ngClass]="[
    'card',
    dispoOrder?.missingData ? 'train-missing-data' : '',
    dispoOrder?.transportReady ? 'train-transport-ready' : 'train-' + dispoOrder?.status,
  ]"
  fxLayout="column"
  fxFlex="100"
  fxLayoutGap="4px"
  fxLayoutAlign="start center"
>
  <div fxFlex="100" fxLayout="column" fxLayoutGap="4px" fxLayoutAlign="center center">
    <div fxFlex="100" fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="center center">
      <span class="train__bookingRef pointer" (click)="goToDispoOrder()">
        {{ dispoOrder.bookingRef }}
      </span>
      <span class="train__text">
        {{ translate(TRANSLOCO_PREFIX + '.customs.' + dispoOrder?.customsProcedure) }}
      </span>
    </div>
    @if (dispoOrder?.customerRef) {
      <span [egTooltip]="dispoOrder?.customerRef?.length > 20 ? dispoOrder?.customerRef : null">
        {{ dispoOrder?.customerRef?.length > 20 ? (dispoOrder?.customerRef | slice: 0 : 20) + '...' : dispoOrder?.customerRef }}
      </span>
    }
    @if (dispoOrder?.services?.length > 0) {
      <rmb-booking-services [services]="dispoOrder.services"></rmb-booking-services>
    }
  </div>
  <div fxFlex="100" fxLayout="row">
    <div fxLayout="row" fxLayoutGap="8px" fxFlex>
      <div class="train__text">{{ dispoOrder.containerId }}</div>
      <div class="train__text">{{ dispoOrder.containerType }}</div>
      <div class="train__text">{{ dispoOrder.grossWeight | egNumber }} kg</div>
    </div>
  </div>
</div>
